export default __webpack_public_path__ + "static/media/due-date.ec61147d.svg";